import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tag } from 'antd';

import { mapIndexed } from 'utils/ramdaAdditions';

export default class ApprovalTags extends Component {
    static propTypes = {
        tags: PropTypes.array
    };

    render () {
        const { tags } = this.props;

        return tags ? (
            <div className='approval-tags'>
                { mapIndexed((tag, index) => <Tag color='#6c9ae3' key={index}>{ tag }</Tag>, tags) }
            </div>
        ) : null;
    }
}
